var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 371.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M397 141.12c63.51 0 115 51.49 115 115s-51.49 115.01-115 115.01-115.02-51.5-115.02-115.01c0-63.51 51.51-115 115.02-115zM28.8 0h389.26c15.73 0 28.52 12.87 28.5 28.53l-.1 95.79c-7.58-2.87-15.46-5.08-23.59-6.59l.07-77.07-125.82 98.89 9.18 9c-2.53 2.13-4.98 4.34-7.34 6.64l-1.51 1.39c-3.29 3.29-6.42 6.72-9.36 10.33l-10.85-10.64-42.14 35.87c-4.49 3.77-11.46 4.22-16.5.12l-44.24-36.09L39.45 282.69h219.27c1.56 8.14 3.82 16 6.72 23.58l-236.95.02C12.74 306.29 0 293.41 0 277.75L.24 28.52C.27 12.83 13.05 0 28.8 0zm-5.19 261.89L154.06 139.8 23.82 41.68l-.21 220.21zM42.65 23.6l183.96 141.86L400.69 23.6H42.65zM449.5 267.53l-51.69 49.97-53.33-51.51 15.44-16.08 26.73 25.82-.06-65.48h22.26l.06 65.52 25.15-24.31 15.44 16.07z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.98148cf20f0474123865e46ab5ae8b49.svg";
export { ForwardRef as ReactComponent };